export default __webpack_public_path__ + "static/media/26.43661845.jpg";